import textStyle from './scatter.tooltip.textStyle'

export default {
  name: "tooltip",
  nickname: "提示",
  desc: "本系列特定的 tooltip 设定。",
  type: "object",
  props: {
    position: {
      name: "position",
      nickname: "位置",
      desc: "<br>",
    },
    formatter: {
      name: "formatter",
      nickname: "文本格式化",
      desc: "<br>",
    },
    backgroundColor: {
      name: "backgroundColor",
      nickname: "背景色",
      desc: "<br>",
      value: "rgba(50,50,50,0.7)",
      defaultValue: "rgba(50,50,50,0.7)",
      type: "pureValue",
    },
    borderColor: {
      name: "borderColor",
      nickname: "边框颜色",
      desc: "<br>",
      value: "#333",
      defaultValue: "#333",
      type: "pureValue",
    },
    borderWidth: {
      name: "borderWidth",
      nickname: "边框宽度",
      desc: "<br>",
      value: 0,
      defaultValue: 0,
    },
    padding: {
      name: "padding",
      nickname: "内边距",
      desc: "<br>",
      value: 5,
      defaultValue: 5,
      type: "pureValue",
    },
    textStyle,
    extraCssText: {
      name: "extraCssText",
      nickname: "额外CSS文本",
      desc: "<br>",
    },
  },
}
